import React from 'react';
import { Container, ListGroup } from 'react-bootstrap';
import { Table } from 'react-bootstrap-icons';
import { useHistory } from 'react-router-dom';

/**
 * ポータル画面
 */
const Portal: React.FunctionComponent = () => {
  const history = useHistory();
  return (
    <Container>
      <ListGroup>
        <ListGroup.Item
          action
          href={history.createHref({ pathname: '/datalist' })}
        >
          <Table size="1.0rem" />
          <span className="mx-3">計測装置データ検索</span>
        </ListGroup.Item>
      </ListGroup>
    </Container>
  );
};

export default Portal;
